// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__3Ne9U","subTitleBold":"BoxSubTitle_subTitleBold__TYUro"};